import { useState, useCallback } from "react";
import type { ToastState } from "types/survey";

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    message: "",
    severity: "success",
  });

  const showToast = useCallback(
    (message: string, severity: ToastState["severity"] = "success") => {
      setToast({ open: true, message, severity });
    },
    []
  );

  const closeToast = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  return {
    toast,
    showToast,
    closeToast,
  };
};
